import * as React from 'react';
import { View, TouchableWithoutFeedback } from 'react-native';
import Marquee from './Marqueue';
import { isValidObject } from './utils';
// import styles from './style';
import TipText from './TipText';
import { LeftIcon, RightIcon } from './TipIcon';
import { TipLayout } from './TipTypes';
import TipsStyle from './style';
import TipStaticStyle from './StaticStyle';
import { qAccessibilityLabel } from '@qnpm/q-design-utils';
const TipStyle = new TipsStyle(false);
export default class BaseTip extends React.Component {
    constructor(props) {
        super(props);
        this.onPress = () => {
            const { onPress, index } = this.props;
            if (onPress) {
                onPress(index);
            }
        };
        this.onClose = () => {
            const { mode, onClose, index } = this.props;
            if (mode === 'closable') {
                this.setState({
                    show: false
                });
            }
            if (onClose) {
                onClose(index);
            }
        };
        this.getTipContent = () => {
            let styles = TipStyle.getStyle();
            let { title, text, marqueeProps, customStyle, layoutType, numberOfLines, needScale } = this.props;
            if (React.isValidElement(text)) {
                return text;
            }
            if (isValidObject(marqueeProps)) {
                return (<Marquee style={styles.text} text={text} {...marqueeProps}/>);
            }
            return (<TipText title={title} layoutType={layoutType} numberOfLines={numberOfLines} customStyle={customStyle} text={text} needScale={needScale}/>);
        };
        TipStyle.setIsScale(props.needScale);
        this.state = {
            show: true
        };
    }
    render() {
        const { mode, rightIcon, numberOfLines, layoutType, customStyle, style, needScale, rightIconType, accessibilityPreName } = this.props;
        let leftIcon = this.props.leftIcon;
        let styles = TipStyle.getStyle();
        const content = (<>
                <LeftIcon icon={leftIcon} brandColor={customStyle.textColor} needScale={needScale}/>
                <View style={[
            styles.container,
            leftIcon && layoutType !== 2
                ? numberOfLines === 1
                    ? styles.left0
                    : styles.left2
                : styles.left12
        ]}>
                    {this.getTipContent()}
                </View>
            </>);
        const main = (<View style={[
            styles.tip,
            { backgroundColor: customStyle === null || customStyle === void 0 ? void 0 : customStyle.backgroundColor },
            style
        ]}>
                {layoutType === TipLayout.VERTICAL_LAYOUT ? (<View style={TipStaticStyle.VerticalContainer}>
                        {content}
                    </View>) : (content)}
                <RightIcon accessibilityPreName={accessibilityPreName} icon={rightIcon} mode={mode} 
        // @ts-ignore
        rightIconType={rightIconType} brandColor={customStyle.operationAreaColor ||
            customStyle.brandColor} needScale={needScale} onClose={this.onClose}/>
            </View>);
        return this.state.show ? (<TouchableWithoutFeedback onPress={this.onPress} accessible={false} {...qAccessibilityLabel(`${accessibilityPreName}qdTip`)}>
                {main}
            </TouchableWithoutFeedback>) : null;
    }
}
BaseTip.defaultProps = {
    mode: '',
    numberOfLines: 1,
    layoutType: 1,
    onPress() { },
    needScale: false,
    accessibilityPreName: ''
};
